import { ConfirmDialog } from '@core/components';
import { useConfirmDialog } from '@core/hooks/useConfirmDialog';
import { type Order, undoReleaseOrder } from '../../api/order';

interface UndoReleaseDialogProps {
  open: boolean;
  onClose: () => void;
  order: Order | null;
  onSuccess?: () => void;
}

const UndoReleaseDialog = ({
  open,
  onClose,
  order,
  onSuccess,
}: UndoReleaseDialogProps) => {
  const { loading, confirm, cancel } = useConfirmDialog({
    open,
    onClose,
    onConfirm: async () => {
      if (!order) return;
      await undoReleaseOrder(order.id);
    },
    onSuccess,
    successMessage: 'Release undone',
    errorMessage: 'Failed to undo release',
  });

  return (
    <ConfirmDialog
      open={open}
      title="Undo release"
      content="This order will return to ready for release and its release type will be cleared. Continue?"
      confirmText="Undo"
      cancelText="Keep"
      onConfirm={confirm}
      onCancel={cancel}
      loading={loading}
    />
  );
};

export default UndoReleaseDialog;
